export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('branch-app-state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const loadAuthToken = () => {
  try {
    const serializedState = localStorage.getItem('auth-data-editor');
    if (serializedState === null) {
      return undefined;
    }
    return serializedState
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('branch-app-state', serializedState);
  } catch {
    // ignore write errors
  }
};
